import { CheckboxWrapper } from '@design-system';
import { useTranslation } from 'next-i18next';

import { CurrencyCode, GlazingOptionView } from '../types';
import { GlazingGuide } from './GlazingGuide';
import { GlazingOption } from './GlazingOption';

export interface GlazingPickerProps {
  groupName: string;
  options: GlazingOptionView[];
  selectedGlazing: string | null;
  currencyCode?: CurrencyCode;
  isFloat?: boolean;
  onSelect: (glazing: string) => void;
}

export const GlazingPicker = ({
  currencyCode,
  groupName,
  isFloat = false,
  onSelect,
  options,
  selectedGlazing,
}: GlazingPickerProps) => {
  const { t } = useTranslation('checkout');

  if (options.length <= 1) return null;

  return (
    <fieldset className="grid gap-3">
      <legend className="flex w-full justify-between gap-3">
        <strong>{t('framing.glazing')}</strong>
        <GlazingGuide />
      </legend>

      <CheckboxWrapper>
        {options.map((option) => (
          <GlazingOption
            key={option.glazing}
            checked={option.glazing === selectedGlazing}
            currencyCode={currencyCode}
            isFloat={isFloat}
            glazing={option.glazing}
            groupName={groupName}
            onSelect={() => onSelect(option.glazing)}
            priceDelta={option.priceDelta}
          />
        ))}
      </CheckboxWrapper>
    </fieldset>
  );
};
